  document.addEventListener('DOMContentLoaded', function () {
    stepsLoader();
  });

  document.addEventListener('shopify:section:load', function () {
    stepsLoader();
  });

  function stepsLoader() {
    const sections = document.querySelectorAll('.pf-howto-steps');
    if(!sections) return;

    sections.forEach((stepsContainer) => {
      const sliderEl = stepsContainer.querySelector('.pf-htsteps-slider');
      const paginationEl = stepsContainer.querySelector('.pf-htsteps-pagination');

      if (!sliderEl || !paginationEl) return;

      new Swiper(sliderEl, {
        slidesPerView: 1,
        spaceBetween: 12,
        pagination: {
          el: paginationEl,
          type: 'progressbar',
        },
        breakpoints: {
          480: {
            slidesPerView: 2,
            spaceBetween: 12,
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1600: {
            slidesPerView: 5,
            spaceBetween: 30,
          },
          2200: {
            slidesPerView: 6,
            spaceBetween: 30,
          },
        },
      });
    });
  }


  // cartdrwar => best slider js

  document.addEventListener('DOMContentLoaded', function () {
    cartBestSeller();
  });

  document.addEventListener('shopify:section:load', function () {
    cartBestSeller();
  });

  function cartBestSeller() {
   var swiper = new Swiper(".pf-best-slider-cart", {
      slidesPerView: 2,
      spaceBetween: 30,
       navigation: {
        nextEl: ".pf-swiper-button-next",
        prevEl: ".pf-swiper-button-prev",
      },
    });
  }


  


